import React from 'react';
import AddFormModal from './../../common/AddFormModal'
import { withGoogleMap, GoogleMap, Marker } from "@react-google-maps/api";
import EdiTable from '../../common/EdiTable'
import $ from 'jquery';
import execAjax from './../../common/execAjax';
import getCookie from './../../common/getCookie';
import Button from './../../common/Button';
import { ToastContainer, toast } from 'react-toastify';

const { Tabs, Tab } = require('react-bootstrap');


class NanpaCodes extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/settings/nanpa_codes',
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRNANPACODEID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Code',
                        'source': 'ATRNANPACODE',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Country (2-letter code)',
                        'source': 'ATRCOUNTRY',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'State (2 letter-code)',
                        'source': 'ATRSTATE',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Geographical Latitude',
                        'source': 'ATRLAT',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Geographical Longitude',
                        'source': 'ATRLON',
                        'type': 'text',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {

        var data = [];
        var opt = {
            url: this.state.url,
            urlattrs: [],
            method: 'get',
            authToken: getCookie('sessid_admin')
        };
        var that = this;
        $.when( execAjax(data, opt) ).done(function(data) {
            that.setState({
                data: data
            });
        }).fail(function(result) {
            that.setState({
                error: result.msg
            });
        });
    }
    onRowAdded(data) {
        var newdata = this.state.data;
        newdata.data.push(data);
        this.setState({data: newdata});
    }
    render(){
        return(
            <div className="row">
                <div className="col-md-12">
                    <Panel title="NANPA Code List" text="Click any cell to edit" />
                    <div className="row">
                        <div className="col-md-12">
                            <AddFormModal
                                bsStyle="add"
                                addButton="true"
                                addButtonValue="Add NANPA Code"
                                metadata={this.state.metadata}
                                url={this.state.url}
                                remotemeta={this.state.data.metadata}
                                onRowAdded={this.onRowAdded.bind(this)}

                            />
                        </div>
                    </div>
                    <div className="row">
                        {/* <div className="col-lg-12">
                            <EdiTable
                                data={this.state.data}
                                metadata={this.state.metadata}
                                url={this.state.url}
                                urlattrs={this.props.urlattrs}
                                token_name = 'sessid_admin'
                            />
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}


// const GettingStartedGoogleMap = withGoogleMap(props => (
//     <GoogleMap
//         ref={props.onMapLoad}
//         defaultZoom={5}
//         defaultCenter={{ lat: 35.8639788, lng: -102.1951168 }}
//         onClick={props.onMapClick}
//     >
//         {props.markers.map(marker => (
//             <Marker
//                 {...marker}
//                 onRightClick={() => props.onMarkerRightClick(marker)}
//                 onDragEnd={e => props.onMarkerDragEnd(marker, e)}
//             />
//         ))}
//     </GoogleMap>
// ));

class NanpaMap extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            markers: [{
                position: {
                    lat: 36.8639788,
                    lng: -103.1951168,
                },
                key: `test1`,
                defaultAnimation: 2,
            }],
            url: 'settings/nanpa_codes',
            data: {
                data: [],
                metadata: []
            },
            edit: false,
            btnText: "Edit"
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        const url = '/admin/settings/nanpa_codes';
        const params = {};

        this.props.childProps.dataProvider.getList(url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    var newmarker = [];
                    response.data.data.map(function (row, index) {
                        newmarker.push({
                            id: row.ATRNANPACODEID,
                            key: row.ATRNANPACODE,
                            position: {
                                lat: parseFloat(row.ATRLAT),
                                lng: parseFloat(row.ATRLON)
                            },
                            label: row.ATRNANPACODE,
                            draggable: true,
                            defaultAnimation: 2,
                        });
                    })
                    this.setState({
                        loading: false,
                        data: response.data,
                        markers: newmarker
                    })
                } else {
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        ).catch(error => {
            toast.error("Something went wrong... backend returned error", {})
        });
    }
   

    handleMapLoad(map) {
        this._mapComponent = map;
        if (map) {
            console.log(map.getZoom());
        }
    }
    handleMapClick(event) {
    }

    handleMarkerDragEnd(targetMarker, ev) {
        if (this.state.edit) {
            this.updateServer(targetMarker.id, ev.latLng.lat(), ev.latLng.lng());
        } else {

            this.setState({errormsg: ''});
        }
    }

    updateServer(id, lat, lon) {
        var data = {ATRLAT : lat, ATRLON : lon};
        var opt = {
            url: this.state.url + '/' + id,
            urlattrs: [],
            method: 'update',
            authToken: getCookie('sessid_admin')
        };
        var that = this;
        $.when( execAjax(data, opt) ).done(function(data) {

            // toastr.options.timeOut = 5000;
            // toastr.options.positionClass = "toast-top-center";
            // toastr.options.closeButton = true;
            // toastr['info']('Code updated');
            that.setState({errormsg: ''});

        }).fail(function(result) {
            that.setState({
                error: result.msg
            });
        });
    }
    toogleEdit() {
        var btnText = (!this.state.edit) ? ("Lock") : ("Edit");

        this.setState({
            edit: !this.state.edit,
            btnText: btnText
        })

    }
    render(){
        return (
            <div className="row">
                <div className="col-md-12">
                    <Panel
                        title="Geographical Location of Dial Codes"
                        text="List of NANPA code geo locations. Click 'Edit' and drag markers to rearrange codes and save changes to server. Warning: There is no Undo!"
                        options = { <Button bsStyle={this.state.edit ? "save" : "edit"} value={ this.state.btnText } onClick={this.toogleEdit.bind(this)}/> }
                    />
                    <div className="row">
                        <div className="col-md-12">
                            <GettingStartedGoogleMap
                                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA2ToALjDdQNGIX3TQLcQ2_ShAjvz1olS4&v=3.exp"
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={<div style={{ height: `600px` }} />}
                                mapElement={<div style={{ height: `600px` }} />}
                                onMapLoad={this.handleMapLoad.bind(this)}
                                onMapClick={this.handleMapClick.bind(this)}
                                markers={this.state.markers}
                                onMarkerRightClick={this.handleMarkerRightClick}
                                onMarkerDragEnd={this.handleMarkerDragEnd.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class Panel extends React.Component {
    render() {
        return(
            <div className="panel panel-default">
                <div className="panel-heading">
                    <div className="panel-title">{ this.props.title }</div>
                    <div className="panel-options"> { this.props.options }</div>
                </div>
                <div className="panel-body">
                    <p>{ this.props.text }</p>
                </div>
            </div>
        )
    }
}



export default class extends React.Component{
    render(){
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Geographical Location of Dial Codes</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {/* <Tabs id="sections" defaultActiveKey={1}>
                            <Tab eventKey={1} title="NANPA Code Map">
                                <NanpaMap  />
                            </Tab>
                            <Tab eventKey={2} title="NANPA Code List">
                                <NanpaCodes  />
                            </Tab>
                        </Tabs> */}
                        <NanpaMap {...this.props}/>
                    </div>
                </div>
           </div>

        )
    }
}


